import React from "react";
import HelperText from "../../../../components/atoms/HelperText";

export const sliceEventHeader = (
  <>
    Splicing <br />
    Event{" "}
    <HelperText
      RenderContent={() => (
        <div>
          <span className="tw-font-bold">Type of splicing event: </span>
          <div>&bull; exon skipping (annotated)</div>
          <div>&bull; exon skipping</div>
          <div>&bull; normal splicing (annotated)</div>
          <div>&bull; cryptic acceptor</div>
          <div>&bull; cryptic donor</div>
        </div>
      )}
    />
  </>
);

export const skippedExonIdHeader = (
  <span>
    Skipped <br />
    Exon ID{" "}
    <HelperText customText="The column reports the ids of the exons skipped, for example '2' refers to skipping of exon 2 in that transcript (not skipping of 2 exons), and '2-3' denotes skipping of exons 2 and 3." />
  </span>
);

export const crypticPositionHeader = (
  <span>
    Cryptic <br />
    Distance{" "}
    <HelperText customText="The column reports the distance of cryptic splice site (relative to donor or acceptor)." />
  </span>
);

export const missplicingInFrameHeader = (
  <span>
    Mis-splicing <br />
    in Frame{" "}
    <HelperText customText="The column reports whether mis-splicing event is in frame or not." />
  </span>
);

export const samplesGtexHeader = (
  <span className="tw-break-normal">
    N. of Samples <br />
    (GTEx){" "}
    <HelperText
      RenderContent={() => (
        <span>
          No. of{" "}
          <a
            href="https://www.gtexportal.org/home/"
            target="_blank"
            rel="noopener noreferrer"
          >
            GTEx
          </a>{" "}
          samples where the event is observed.
        </span>
      )}
    />
  </span>
);

export const maxReadCountHeader = (
  <span>
    Max Read Count
    <br />
    (GTEx){" "}
    <HelperText customText="The column reports the maximum no. of reads observed in GTEx." />
  </span>
);

export const nSamplesHeaderHg19 = (
  <span>
    N. of Samples <br />
    (Intropolis){" "}
    <HelperText customText="Intropolis is a set of ~42M exon-exon junctions found across 21,504 human RNA-seq samples from the Sequence Read Archive (SRA)." />
  </span>
);

export const nSamplesHeaderHg38 = (
  <span>
    N. of Samples <br />
    (SRA){" "}
    <HelperText customText="The column reports the maximum no. of reads observed in SRA. SRA (Sequence Read Arcchive) is an online archive of high-throughput RNA sequencing data." />
  </span>
);

export const spliceJunctionHeader = (
  <span>
    Splice <br />
    Junction{" "}
    <HelperText
      RenderContent={() => {
        return (
          <div>
            <div className="tw-font-bold">The column reports:</div>
            <div>&bull; The chromosome for the splicing event</div>
            <div>&bull; Splicing event donor position</div>
            <div>&bull; Splicing event acceptor position.</div>
            <div className="tw-h-2" />
            <div>
              In the case of reporting splicing events for the exon donor
              position, the splice junction is reported as{" "}
              <b>chr:donor-acceptor</b>.
              <div className="tw-h-2" />
              Conversely, when reporting results for the exon acceptor position,
              the splice junction is reported as <b>chr:acceptor-donor.</b>
            </div>
            <div className="tw-text-xs tw-text-blueGray-400 tw-mt-4">
              Position adjusted to 1-based-indexing
            </div>
          </div>
        );
      }}
    />
  </span>
);
